import { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";

// ── Brand tokens (mesmas cores do app) ──────────────────────
const G = {
  green:   "#40916c",
  lime:    "#D0F57A",
  bg:      "#0E1210",        // quase preto com leve tom verde
  bgCard:  "#161C18",        // card escuro
  bgCard2: "#1C2620",
  border:  "rgba(255,255,255,0.08)",
  text:    "#FFFFFF",
  muted:   "rgba(255,255,255,0.52)",
  surface: "#232E27",
};

const FONT_DISPLAY = "'LyonDisplay', Georgia, serif";
const FONT_BODY    = "'SuisseIntl', -apple-system, sans-serif";

// ── Login / Signup Modal ─────────────────────────────────────
function LoginModal({ onClose, onLogin, initialTab = "login" }) {
  const [tab,      setTab]      = useState(initialTab);
  const [name,     setName]     = useState("");
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);

  const inputStyle = { width:"100%",padding:"12px 14px",background:"rgba(255,255,255,0.06)",border:`1px solid ${G.border}`,borderRadius:10,fontSize:14,fontFamily:FONT_BODY,outline:"none",color:G.text,boxSizing:"border-box" };
  const labelStyle = { fontSize:11,fontWeight:600,color:G.muted,display:"block",marginBottom:6,letterSpacing:"0.07em",textTransform:"uppercase",fontFamily:FONT_BODY };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const { data, error: ae } = await supabase.auth.signInWithPassword({
      email: email.trim().toLowerCase(), password,
    });
    if (ae) { setError("E-mail ou senha incorretos."); setLoading(false); }
    else onLogin(data.user);
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!name.trim()) { setError("Informe seu nome."); return; }
    setLoading(true); setError("");
    const { error: ae } = await supabase.auth.signUp({
      email: email.trim().toLowerCase(), password,
      options: { data: { display_name: name.trim() } },
    });
    if (ae) { setError(ae.message); setLoading(false); return; }
    // Sign in immediately (works when email confirmation is disabled in Supabase dashboard)
    const { data: loginData, error: le } = await supabase.auth.signInWithPassword({
      email: email.trim().toLowerCase(), password,
    });
    if (le) { setError("Conta criada! Entre com seu e-mail e senha."); setLoading(false); return; }
    const user = loginData.user;
    if (user) {
      await supabase.from("user_profiles").upsert({ user_id: user.id, display_name: name.trim(), salary: 0, updated_at: new Date().toISOString() });
      onLogin(user);
    }
  };

  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(8px)" }}
      onClick={onClose}>
      <div style={{ background:G.bgCard,border:`1px solid ${G.border}`,borderRadius:20,padding:"40px 36px",width:"92%",maxWidth:400,boxShadow:"0 32px 80px rgba(0,0,0,0.5)" }}
        onClick={e => e.stopPropagation()}>
        <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:28 }}>
          <div>
            <div style={{ fontFamily:FONT_DISPLAY,fontSize:28,fontWeight:400,color:G.text,lineHeight:1.1,marginBottom:6 }}>
              {tab === "login" ? "Entrar" : "Criar conta"}
            </div>
            <div style={{ fontSize:13,color:G.muted,fontFamily:FONT_BODY }}>
              {tab === "login" ? "Acesse sua conta Radar de Gastos" : "Comece a controlar seus gastos"}
            </div>
          </div>
          <button onClick={onClose} style={{ background:"rgba(255,255,255,0.07)",border:"none",borderRadius:8,width:32,height:32,cursor:"pointer",color:G.muted,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,fontFamily:FONT_BODY }}>✕</button>
        </div>

        {tab === "login" ? (
          <form onSubmit={handleLogin}>
            <div style={{ marginBottom:14 }}>
              <label style={labelStyle}>E-MAIL</label>
              <input type="email" value={email} onChange={e => { setEmail(e.target.value); setError(""); }} required placeholder="seu@email.com" style={inputStyle}/>
            </div>
            <div style={{ marginBottom:24 }}>
              <label style={labelStyle}>SENHA</label>
              <div style={{ position:"relative" }}>
                <input type={showPass?"text":"password"} value={password} onChange={e => { setPassword(e.target.value); setError(""); }} required placeholder="••••••••"
                  style={{ ...inputStyle, padding:"12px 44px 12px 14px" }}/>
                <button type="button" onClick={() => setShowPass(v=>!v)}
                  style={{ position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",color:G.muted,fontSize:15 }}>
                  {showPass?"🙈":"👁"}
                </button>
              </div>
            </div>
            {error && <div style={{ color:"#F87171",fontSize:13,marginBottom:16,padding:"10px 14px",background:"rgba(248,113,113,0.1)",borderRadius:8,fontFamily:FONT_BODY }}>{error}</div>}
            <button type="submit" disabled={loading}
              style={{ width:"100%",padding:"13px",borderRadius:10,border:"none",background:loading?"rgba(64,145,108,0.5)":G.green,color:"#fff",fontWeight:600,fontSize:14,cursor:loading?"not-allowed":"pointer",fontFamily:FONT_BODY,letterSpacing:"0.01em" }}>
              {loading ? "Entrando..." : "Entrar →"}
            </button>
            <div style={{ textAlign:"center",marginTop:20,fontSize:13,color:G.muted,fontFamily:FONT_BODY }}>
              Não tem conta?{" "}
              <span style={{ color:G.lime,fontWeight:600,cursor:"pointer" }} onClick={() => { setTab("signup"); setError(""); }}>Criar conta</span>
            </div>
          </form>
        ) : (
          <form onSubmit={handleSignup}>
            <div style={{ marginBottom:14 }}>
              <label style={labelStyle}>SEU NOME</label>
              <input type="text" value={name} onChange={e => { setName(e.target.value); setError(""); }} required placeholder="Como posso te chamar?"
                style={inputStyle}/>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={labelStyle}>E-MAIL</label>
              <input type="email" value={email} onChange={e => { setEmail(e.target.value); setError(""); }} required placeholder="seu@email.com" style={inputStyle}/>
            </div>
            <div style={{ marginBottom:24 }}>
              <label style={labelStyle}>SENHA</label>
              <div style={{ position:"relative" }}>
                <input type={showPass?"text":"password"} value={password} onChange={e => { setPassword(e.target.value); setError(""); }} required placeholder="Mínimo 6 caracteres"
                  style={{ ...inputStyle, padding:"12px 44px 12px 14px" }}/>
                <button type="button" onClick={() => setShowPass(v=>!v)}
                  style={{ position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",color:G.muted,fontSize:15 }}>
                  {showPass?"🙈":"👁"}
                </button>
              </div>
            </div>
            {error && <div style={{ color:"#F87171",fontSize:13,marginBottom:16,padding:"10px 14px",background:"rgba(248,113,113,0.1)",borderRadius:8,fontFamily:FONT_BODY }}>{error}</div>}
            <button type="submit" disabled={loading}
              style={{ width:"100%",padding:"13px",borderRadius:10,border:"none",background:loading?"rgba(64,145,108,0.5)":G.green,color:"#fff",fontWeight:600,fontSize:14,cursor:loading?"not-allowed":"pointer",fontFamily:FONT_BODY,letterSpacing:"0.01em" }}>
              {loading ? "Criando conta..." : "Criar conta →"}
            </button>
            <div style={{ textAlign:"center",marginTop:20,fontSize:13,color:G.muted,fontFamily:FONT_BODY }}>
              Já tem conta?{" "}
              <span style={{ color:G.lime,fontWeight:600,cursor:"pointer" }} onClick={() => { setTab("login"); setError(""); }}>Entrar</span>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

// ── Hero interactive demo ─────────────────────────────────────
const DEMO_CATS = [
  { id:"alimentacao", label:"Alimentação", color:"#22C55E",  icon:"🍽️", total:"R$ 1.024,50", change:"+12%", changeUp:true,
    bars:[42,58,35,71,50,80,62,44,68,55,72,100], highlight:11 },
  { id:"transporte",  label:"Transporte",  color:"#8B5CF6",  icon:"🚗", total:"R$ 487,20",   change:"-5%",  changeUp:false,
    bars:[60,55,80,45,70,50,90,65,40,75,55,85], highlight:6 },
  { id:"lazer",       label:"Lazer",       color:"#EC4899",  icon:"🎮", total:"R$ 312,00",   change:"+3%",  changeUp:true,
    bars:[30,40,55,35,60,45,70,50,65,40,80,95], highlight:10 },
  { id:"moradia",     label:"Moradia",     color:"#F59E0B",  icon:"🏠", total:"R$ 1.418,10", change:"0%",   changeUp:null,
    bars:[100,100,100,100,100,100,100,100,100,100,100,100], highlight:11 },
];

function HeroDemoCard({ onCTA }) {
  const [active, setActive] = useState(0);
  const [animKey, setAnimKey] = useState(0);
  const cat = DEMO_CATS[active];

  const handleCat = (i) => {
    setActive(i);
    setAnimKey(k => k+1);
  };

  return (
    <div style={{ width:"100%",maxWidth:780,background:G.bgCard,border:`1px solid ${G.border}`,borderRadius:20,padding:"clamp(16px,4vw,28px)",textAlign:"left",boxShadow:"0 40px 80px rgba(0,0,0,0.5)" }}>
      {/* Header row */}
      <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,gap:12,flexWrap:"wrap" }}>
        <div>
          <div style={{ fontSize:11,fontWeight:600,color:G.muted,letterSpacing:"0.07em",textTransform:"uppercase",fontFamily:FONT_BODY,marginBottom:6 }}>GASTOS ESTE MÊS · {cat.icon} {cat.label}</div>
          <div key={animKey+"v"} style={{ fontFamily:FONT_DISPLAY,fontSize:"clamp(28px,5vw,40px)",fontWeight:400,color:cat.color,lineHeight:1,transition:"color 0.3s" }}>{cat.total}</div>
          <div style={{ fontSize:12,color:cat.changeUp===true?"#F87171":cat.changeUp===false?"#86EFAC":G.muted,fontFamily:FONT_BODY,marginTop:5 }}>
            {cat.changeUp===true?"▲":cat.changeUp===false?"▼":"→"} {cat.change} em relação ao mês anterior
          </div>
        </div>
        {/* Category pills */}
        <div style={{ display:"flex",gap:6,flexWrap:"wrap",justifyContent:"flex-end" }}>
          {DEMO_CATS.map((c,i) => (
            <button key={c.id} onClick={() => handleCat(i)}
              style={{ background:active===i?cat.color+"22":"rgba(255,255,255,0.04)", border:`1.5px solid ${active===i?cat.color:G.border}`, borderRadius:8, padding:"6px 12px", fontSize:12, color:active===i?cat.color:G.muted, fontFamily:FONT_BODY, whiteSpace:"nowrap", cursor:"pointer", transition:"all 0.2s", fontWeight:active===i?600:400 }}>
              {c.icon} {c.label}
            </button>
          ))}
        </div>
      </div>

      {/* Bar chart */}
      <div key={animKey} style={{ display:"flex",gap:"clamp(2px,0.6vw,5px)",alignItems:"flex-end",height:80 }}>
        {cat.bars.map((h,i) => (
          <div key={i} style={{ flex:1, height:`${h}%`, borderRadius:"4px 4px 0 0",
            background: i===cat.highlight ? cat.color : `${cat.color}${Math.round(0.15*255+h/200*255).toString(16).padStart(2,"0")}`,
            transition:"height 0.5s cubic-bezier(.4,0,.2,1), background 0.3s",
            boxShadow: i===cat.highlight ? `0 0 12px ${cat.color}66` : "none" }}/>
        ))}
      </div>
      <div style={{ display:"flex",justifyContent:"space-between",marginTop:6 }}>
        {["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"].map((m,i) => (
          <div key={i} style={{ flex:1,textAlign:"center",fontSize:"clamp(8px,1vw,10px)",color:i===cat.highlight?cat.color:G.muted,fontFamily:FONT_BODY,fontWeight:i===cat.highlight?700:400,transition:"color 0.3s" }}>{m}</div>
        ))}
      </div>
    </div>
  );
}

// ── Data ─────────────────────────────────────────────────────
const FEATURES = [
  { tag:"IMPORTAÇÃO", title:"PDF, CSV, OFX, XLS", desc:"Nubank, Inter e qualquer banco. Arraste o arquivo e todas as transações são extraídas automaticamente." },
  { tag:"INTELIGÊNCIA", title:"Categorização por IA", desc:"Cada gasto é identificado e classificado automaticamente. Ajuste manualmente quando quiser." },
  { tag:"ANÁLISE", title:"Dashboards interativos", desc:"Gráficos de fluxo, comparativo mensal, projeção de parcelas futuras e muito mais." },
  { tag:"ORÇAMENTO", title:"Controle por categoria", desc:"Defina limites e acompanhe em tempo real quanto do orçamento já foi usado." },
  { tag:"PATRIMÔNIO", title:"Contas e investimentos", desc:"Visão consolidada de todos os seus ativos, cartões e contas bancárias em um único lugar." },
  { tag:"PARCELAS", title:"Projeção automática", desc:"Detecta compras parceladas e projeta mês a mês o quanto cada parcela vai custar." },
];

const STEPS = [
  { n:"01", title:"Importe sua fatura", desc:"Arraste o PDF do Nubank, Inter ou qualquer banco. Ou importe CSV, OFX, XLS." },
  { n:"02", title:"Revise e confirme", desc:"Transações categorizadas automaticamente. Ajuste o que precisar antes de salvar." },
  { n:"03", title:"Analise seus gastos", desc:"Dashboard completo com gráficos, comparativo mensal e projeção de parcelas." },
];

const TESTIMONIALS = [
  { name:"Marina S.", role:"Designer Freelancer", text:"Finalmente entendi para onde ia meu dinheiro. O import automático das faturas do Nubank mudou minha vida." },
  { name:"Rafael T.", role:"Analista de TI", text:"Reduzi meus gastos em 22% só de ter visibilidade. A categorização automática é impressionante." },
  { name:"Carolina M.", role:"Médica", text:"O único app que consigo manter atualizado. Simples, rápido e completo." },
];

const FAQS = [
  { q:"Como importo minha fatura do Nubank?", a:"Baixe o PDF da fatura no app do Nubank, acesse a aba Faturas no Radar de Gastos e arraste o arquivo. O sistema detecta automaticamente o formato e extrai todas as transações." },
  { q:"O Banco Inter também é suportado?", a:"Sim! O Banco Inter tem parser dedicado. Basta importar o PDF da fatura e todas as transações são extraídas e categorizadas automaticamente." },
  { q:"Posso importar imagens de faturas?", a:"Sim. Para PNG/JPG, o sistema usa IA (Claude Vision) para ler e extrair as transações. É necessário inserir sua chave Anthropic na aba Faturas." },
  { q:"Meus dados ficam seguros?", a:"Seus dados são salvos com segurança no banco de dados Supabase, protegidos por autenticação. Nenhuma informação financeira é compartilhada com terceiros." },
  { q:"Funciona no celular?", a:"Sim! O Radar de Gastos é totalmente responsivo, com menu lateral recolhível e interface adaptada para mobile." },
];

// ── Main Component ───────────────────────────────────────────
export default function LandingPage({ onLogin }) {
  const [modalTab,  setModalTab]  = useState(null); // null | "login" | "signup"
  const [openFaq,   setOpenFaq]   = useState(null);

  return (
    <div style={{ fontFamily:FONT_BODY, color:G.text, background:G.bg, minHeight:"100vh" }}>

      {/* ════════ NAVBAR ════════ */}
      <nav style={{ position:"fixed",top:0,left:0,right:0,zIndex:200,padding:"0 5%",borderBottom:`1px solid ${G.border}`,background:"rgba(14,18,16,0.85)",backdropFilter:"blur(12px)" }}>
        <div style={{ maxWidth:1200,margin:"0 auto",display:"flex",alignItems:"center",justifyContent:"space-between",height:60 }}>
          {/* Logo */}
          <div style={{ display:"flex",alignItems:"center",gap:10 }}>
            <img src="/logo-lime.png" alt="Radar de Gastos" style={{ width:34,height:34,objectFit:"contain" }}/>
            <span style={{ fontFamily:FONT_DISPLAY,fontSize:22,fontWeight:400,color:"#FFFFFF",letterSpacing:"-0.03em" }}>Radar de Gastos</span>
          </div>
          {/* Actions */}
          <div style={{ display:"flex",gap:8,alignItems:"center" }}>
            <button onClick={() => setModalTab("login")}
              style={{ padding:"8px 18px",borderRadius:8,border:"none",background:"transparent",color:G.muted,fontWeight:500,fontSize:13,cursor:"pointer",fontFamily:FONT_BODY,letterSpacing:"0.01em" }}>
              Entrar
            </button>
            <button onClick={() => setModalTab("signup")}
              style={{ padding:"8px 18px",borderRadius:8,border:`1.5px solid ${G.text}`,background:"transparent",color:G.text,fontWeight:600,fontSize:13,cursor:"pointer",fontFamily:FONT_BODY,letterSpacing:"0.02em",display:"flex",alignItems:"center",gap:6 }}>
              Começar →
            </button>
          </div>
        </div>
      </nav>

      {/* ════════ HERO ════════ */}
      <section style={{ minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",textAlign:"center",padding:"120px 5% 80px",position:"relative",overflow:"hidden" }}>
        {/* Background glow */}
        <div style={{ position:"absolute",top:"30%",left:"50%",transform:"translate(-50%,-50%)",width:600,height:400,background:`radial-gradient(ellipse,${G.green}22 0%,transparent 70%)`,pointerEvents:"none" }}/>

        <div style={{ display:"inline-flex",alignItems:"center",gap:8,background:"rgba(208,245,122,0.1)",border:`1px solid ${G.lime}30`,borderRadius:99,padding:"5px 14px",marginBottom:32,fontSize:12,color:G.lime,fontWeight:600,letterSpacing:"0.05em",textTransform:"uppercase",fontFamily:FONT_BODY }}>
          ✦ Controle financeiro inteligente
        </div>

        <h1 style={{ fontFamily:FONT_DISPLAY,fontSize:"clamp(52px,8vw,96px)",fontWeight:400,color:G.text,lineHeight:1.0,letterSpacing:"-0.03em",marginBottom:28,maxWidth:800 }}>
          <em style={{ fontStyle:"italic",color:G.lime }}>Entenda</em>{" "}seus gastos.
        </h1>

        <p style={{ fontSize:"clamp(15px,2vw,18px)",color:G.muted,lineHeight:1.7,marginBottom:40,maxWidth:520,fontFamily:FONT_BODY }}>
          Importe faturas do Nubank, Inter e outros bancos. Categorização automática. Dashboards que mostram exatamente para onde vai seu dinheiro.
        </p>

        <div style={{ display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap",marginBottom:64 }}>
          <button onClick={() => setModalTab("signup")}
            style={{ padding:"14px 32px",borderRadius:10,border:"none",background:G.green,color:"#fff",fontWeight:600,fontSize:15,cursor:"pointer",fontFamily:FONT_BODY,letterSpacing:"0.01em",boxShadow:`0 0 40px ${G.green}40` }}>
            Começar agora →
          </button>
          <button onClick={() => setModalTab("login")}
            style={{ padding:"14px 32px",borderRadius:10,border:`1.5px solid ${G.border}`,background:"rgba(255,255,255,0.04)",color:G.muted,fontWeight:500,fontSize:15,cursor:"pointer",fontFamily:FONT_BODY }}>
            Já tenho conta
          </button>
        </div>

        <HeroDemoCard onCTA={() => setModalTab("login")} />
      </section>

      {/* ════════ FEATURES GRID ════════ */}
      <section style={{ padding:"100px 5%",borderTop:`1px solid ${G.border}` }}>
        <div style={{ maxWidth:1100,margin:"0 auto" }}>
          <div style={{ marginBottom:64 }}>
            <div style={{ fontSize:11,fontWeight:600,color:G.lime,letterSpacing:"0.1em",textTransform:"uppercase",fontFamily:FONT_BODY,marginBottom:16 }}>FUNCIONALIDADES</div>
            <h2 style={{ fontFamily:FONT_DISPLAY,fontSize:"clamp(32px,4vw,52px)",fontWeight:400,color:G.text,lineHeight:1.1,letterSpacing:"-0.02em",maxWidth:560 }}>
              Tudo que você precisa em um só lugar.
            </h2>
          </div>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:2 }}>
            {FEATURES.map((f,i) => (
              <div key={i} style={{ background:i%2===0?G.bgCard:G.bgCard2,padding:"36px 32px",borderRadius:0,border:`1px solid ${G.border}`,borderRadius:i===0?"12px 0 0 0":i===1?"0 12px 0 0":i===4?"0 0 0 12px":i===5?"0 0 12px 0":"0" }}>
                <div style={{ fontSize:10,fontWeight:700,color:G.lime,letterSpacing:"0.1em",textTransform:"uppercase",fontFamily:FONT_BODY,marginBottom:16 }}>{f.tag}</div>
                <div style={{ fontFamily:FONT_DISPLAY,fontSize:22,fontWeight:400,color:G.text,marginBottom:12,lineHeight:1.2 }}>{f.title}</div>
                <div style={{ fontSize:14,color:G.muted,lineHeight:1.7,fontFamily:FONT_BODY }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════ HOW IT WORKS ════════ */}
      <section style={{ padding:"100px 5%",borderTop:`1px solid ${G.border}` }}>
        <div style={{ maxWidth:1000,margin:"0 auto" }}>
          <div style={{ marginBottom:64,textAlign:"center" }}>
            <div style={{ fontSize:11,fontWeight:600,color:G.lime,letterSpacing:"0.1em",textTransform:"uppercase",fontFamily:FONT_BODY,marginBottom:16 }}>COMO FUNCIONA</div>
            <h2 style={{ fontFamily:FONT_DISPLAY,fontSize:"clamp(30px,4vw,52px)",fontWeight:400,color:G.text,lineHeight:1.1,letterSpacing:"-0.02em" }}>
              Em 3 passos simples.
            </h2>
          </div>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))",gap:1 }}>
            {STEPS.map((s,i) => (
              <div key={i} style={{ padding:"40px 32px",background:G.bgCard,border:`1px solid ${G.border}`,borderRadius:i===0?"12px 0 0 12px":i===2?"0 12px 12px 0":"0",position:"relative",overflow:"hidden" }}>
                <div style={{ fontFamily:FONT_DISPLAY,fontSize:56,fontWeight:400,color:`${G.green}30`,lineHeight:1,marginBottom:20,letterSpacing:"-0.04em" }}>{s.n}</div>
                <div style={{ fontFamily:FONT_DISPLAY,fontSize:22,fontWeight:400,color:G.text,marginBottom:12,lineHeight:1.2 }}>{s.title}</div>
                <div style={{ fontSize:14,color:G.muted,lineHeight:1.7,fontFamily:FONT_BODY }}>{s.desc}</div>
                {i < 2 && <div style={{ position:"absolute",right:-1,top:"50%",transform:"translateY(-50%)",width:2,height:40,background:G.green,borderRadius:1 }}/>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════ TESTIMONIALS ════════ */}
      <section style={{ padding:"100px 5%",borderTop:`1px solid ${G.border}` }}>
        <div style={{ maxWidth:1000,margin:"0 auto" }}>
          <div style={{ marginBottom:64 }}>
            <div style={{ fontSize:11,fontWeight:600,color:G.lime,letterSpacing:"0.1em",textTransform:"uppercase",fontFamily:FONT_BODY,marginBottom:16 }}>DEPOIMENTOS</div>
            <h2 style={{ fontFamily:FONT_DISPLAY,fontSize:"clamp(30px,4vw,52px)",fontWeight:400,color:G.text,lineHeight:1.1,letterSpacing:"-0.02em",maxWidth:500 }}>
              O que dizem nossos usuários.
            </h2>
          </div>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",gap:16 }}>
            {TESTIMONIALS.map((t,i) => (
              <div key={i} style={{ background:G.bgCard,border:`1px solid ${G.border}`,borderRadius:16,padding:"32px 28px" }}>
                <div style={{ display:"flex",gap:2,marginBottom:20 }}>
                  {[...Array(5)].map((_,j) => <span key={j} style={{ color:G.lime,fontSize:14 }}>★</span>)}
                </div>
                <div style={{ fontFamily:FONT_DISPLAY,fontSize:18,fontWeight:400,color:G.text,lineHeight:1.5,marginBottom:24,fontStyle:"italic" }}>"{t.text}"</div>
                <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                  <div style={{ width:36,height:36,borderRadius:"50%",background:G.green,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:13,fontFamily:FONT_BODY }}>{t.name[0]}</div>
                  <div>
                    <div style={{ fontSize:13,fontWeight:600,color:G.text,fontFamily:FONT_BODY }}>{t.name}</div>
                    <div style={{ fontSize:12,color:G.muted,fontFamily:FONT_BODY }}>{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════ FAQ ════════ */}
      <section style={{ padding:"100px 5%",borderTop:`1px solid ${G.border}` }}>
        <div style={{ maxWidth:720,margin:"0 auto" }}>
          <div style={{ marginBottom:52,textAlign:"center" }}>
            <div style={{ fontSize:11,fontWeight:600,color:G.lime,letterSpacing:"0.1em",textTransform:"uppercase",fontFamily:FONT_BODY,marginBottom:16 }}>FAQ</div>
            <h2 style={{ fontFamily:FONT_DISPLAY,fontSize:"clamp(28px,4vw,48px)",fontWeight:400,color:G.text,lineHeight:1.1,letterSpacing:"-0.02em" }}>
              Perguntas frequentes.
            </h2>
          </div>
          <div style={{ display:"flex",flexDirection:"column",gap:0 }}>
            {FAQS.map((f,i) => (
              <div key={i} style={{ borderTop:`1px solid ${G.border}`,overflow:"hidden" }}>
                <button onClick={() => setOpenFaq(openFaq===i?null:i)}
                  style={{ width:"100%",display:"flex",justifyContent:"space-between",alignItems:"center",padding:"22px 0",background:"none",border:"none",cursor:"pointer",fontFamily:FONT_BODY,fontSize:15,fontWeight:500,color:G.text,textAlign:"left",gap:16 }}>
                  <span>{f.q}</span>
                  <span style={{ fontSize:22,color:G.muted,flexShrink:0,transform:openFaq===i?"rotate(45deg)":"none",transition:"transform 0.2s",lineHeight:1 }}>+</span>
                </button>
                {openFaq===i && (
                  <div style={{ padding:"0 0 22px",fontSize:14,color:G.muted,lineHeight:1.75,fontFamily:FONT_BODY }}>{f.a}</div>
                )}
              </div>
            ))}
            <div style={{ borderTop:`1px solid ${G.border}` }}/>
          </div>
        </div>
      </section>

      {/* ════════ CTA ════════ */}
      <section style={{ padding:"100px 5%",borderTop:`1px solid ${G.border}`,textAlign:"center",position:"relative",overflow:"hidden" }}>
        <div style={{ position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:500,height:300,background:`radial-gradient(ellipse,${G.green}18 0%,transparent 70%)`,pointerEvents:"none" }}/>
        <div style={{ maxWidth:600,margin:"0 auto",position:"relative" }}>
          <h2 style={{ fontFamily:FONT_DISPLAY,fontSize:"clamp(36px,5vw,64px)",fontWeight:400,color:G.text,marginBottom:20,lineHeight:1.05,letterSpacing:"-0.03em" }}>
            Comece a entender<br/>seu dinheiro.
          </h2>
          <p style={{ fontSize:16,color:G.muted,marginBottom:40,lineHeight:1.6,fontFamily:FONT_BODY }}>Importe sua primeira fatura em menos de 1 minuto.</p>
          <button onClick={() => setModalTab("login")}
            style={{ padding:"16px 40px",borderRadius:10,border:"none",background:G.green,color:"#fff",fontWeight:600,fontSize:16,cursor:"pointer",fontFamily:FONT_BODY,letterSpacing:"0.01em",boxShadow:`0 0 48px ${G.green}35` }}>
            Começar agora →
          </button>
        </div>
      </section>

      {/* ════════ FOOTER ════════ */}
      <footer style={{ borderTop:`1px solid ${G.border}`,padding:"32px 5%",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12 }}>
        <div style={{ display:"flex",alignItems:"center",gap:8 }}>
          <img src="/logo-lime.png" alt="Radar de Gastos" style={{ width:24,height:24,objectFit:"contain" }}/>
          <span style={{ fontSize:13,fontWeight:700,color:"#FFFFFF",fontFamily:FONT_DISPLAY }}>Radar de Gastos</span>
        </div>
        <p style={{ fontSize:12,color:G.muted,fontFamily:FONT_BODY }}>© {new Date().getFullYear()} Radar de Gastos · Todos os direitos reservados</p>
      </footer>

      {modalTab && <LoginModal onClose={() => setModalTab(null)} onLogin={onLogin} initialTab={modalTab}/>}
    </div>
  );
}
